import { NormalizedEntity } from 'Interfaces/Common';
import { GridItem } from 'Interfaces/Grid';
import { createReducer } from 'typesafe-actions';

import { toggleEmailNotification } from '../document/actionCreators';

import { getGrid, getGridForSignatureRequests, updateGrid } from './actionCreators';

export default createReducer({} as NormalizedEntity<GridItem>)
  .handleAction([updateGrid.success], (state, action) => ({
    ...state,
    [action.payload.id]: action.payload,
  }))
  .handleAction([toggleEmailNotification.success], (state, action) => ({
    ...state,
    [action.payload.entityId]: {
      ...state[action.payload.entityId],
      documents: {
        ...state[action.payload.entityId].documents!,
        disableReminders: action.payload.documents!.disableReminders,
      },
    },
  }))
  .handleAction(
    [getGrid.success, getGridForSignatureRequests.success],
    (state, action) => ({
      ...action.payload.grid,
    }),
  );
